import {createColumnHelper} from "@tanstack/react-table";
import CustomerTableAction from "../../views/customers/CustomerTableAction";
import Card from "../../components/UI/Card";
import Table from "../../components/UI/Table";
import {getCustomers} from "../../api/customers";
import CustomerFilterComponent from "../../views/customers/CustomerFilterComponent";
import {useState} from "react";
import CustomerCardActions from "../../views/customers/CustomerCardActions";
import CustomerTableStatuscAction from "../../views/customers/CustomerTableStatuscAction";

const CustomerList = ()=> {
    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor('name', {
            id: 'name',
            header: 'Name'
        }),
        columnHelper.accessor('username', {
            id: 'username',
            header: 'Username'
        }),
        columnHelper.accessor('phone', {
            id: 'phone',
            header: 'Phone'
        }),
        columnHelper.accessor('email', {
            id: 'email',
            header: 'Email'
        }),
        columnHelper.accessor('created_at', {
            id: 'created_at',
            header: 'Created At'
        }),
        columnHelper.accessor('last_login', {
            id: 'last_login',
            header: 'Last Login'
        }),
        columnHelper.accessor('Status', {
            id: 'Status',
            header: 'Status',
            cell: props => <CustomerTableStatuscAction customer={props.row.original}/>
        }),
        columnHelper.display( {
            id: 'actions',
            header: "Actions",
            classes:'text_right',
            cell: props => <CustomerTableAction id={props.row.original.id} />
        }),
    ];

    const [params, setParams] = useState({
        per_page: 20,
        page: 1,
        search: ''
    })

    return (
        <>
            <Card title={"Customers"} CardActions={<CustomerCardActions />}>
                <CustomerFilterComponent searchHandler={setParams} params={params} />
                <Table
                    queryKey={"customers"}
                    columns={columns}
                    queryParams={{...params}}
                    queryFn={getCustomers}
                ></Table>
            </Card>
        </>
    )
}

export default CustomerList